"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FacebookSignInButton = void 0;

var _core = require("@material-ui/core");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Facebook = _interopRequireDefault(require("../../../icons/social/023Facebook"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    icon: {
      marginRight: theme.spacing(1),
      color: theme.palette.getContrastText(theme.palette.primary.main)
    }
  };
});

var FacebookSignInButton = function FacebookSignInButton(_ref) {
  var onSignIn = _ref.onSignIn,
      onError = _ref.onError,
      label = _ref.label,
      iconProps = _ref.iconProps,
      props = _objectWithoutProperties(_ref, ["onSignIn", "onError", "label", "iconProps"]);

  var classes = useStyles();

  var handleFacebookSignIn = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var provider;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              _context.prev = 1;
              provider = new firebase.auth.FacebookAuthProvider();
              _context.next = 5;
              return firebase.auth().signInWithPopup(provider);

            case 5:
              if (onSignIn) {
                onSignIn();
              }

              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.error('Error during facebook signin', _context.t0);

              if (onError) {
                onError(_context.t0);
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    return function handleFacebookSignIn(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_core.Button, _extends({
    color: "primary",
    size: "large",
    variant: "contained",
    onClick: handleFacebookSignIn
  }, props), /*#__PURE__*/_react.default.createElement(_core.SvgIcon, _extends({
    component: _Facebook.default
  }, iconProps, {
    className: (0, _clsx.default)(classes.icon, iconProps === null || iconProps === void 0 ? void 0 : iconProps.className)
  })), label);
};

exports.FacebookSignInButton = FacebookSignInButton;
FacebookSignInButton.propTypes = {
  label: _propTypes.default.string.isRequired
};
var _default = FacebookSignInButton;
exports.default = _default;